(function () {
  'use strict';

  const MOBILE_MAX = 749;

  function init() {
    if (window.innerWidth > MOBILE_MAX) return;

    const bar        = document.getElementById('hc-sticky-atc');
    const barBtn     = document.getElementById('hc-sticky-atc-btn');
    const sizeLabel  = document.getElementById('hc-sticky-size');
    const sectionId  = bar && bar.dataset.sectionId;
    const nativeBtn  = sectionId && document.getElementById('ProductSubmitButton-' + sectionId);
    const gokwikBtn  = document.getElementById('gokwik-buy-now');

    if (!bar || !nativeBtn) return;

    // Proxy click → GoKwik's own buy-now button so GoKwik handles everything
    barBtn.addEventListener('click', function () {
      if (gokwikBtn && gokwikBtn.style.display !== 'none') {
        gokwikBtn.click();
      } else {
        nativeBtn.click();
      }
    });

    // Show bar only when native buy area is off-screen AND product is not sold out
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var isSoldOut = nativeBtn.hasAttribute('disabled');
        var gokwikHidden = gokwikBtn && gokwikBtn.style.display === 'none';

        if (!entry.isIntersecting && !isSoldOut && !gokwikHidden) {
          bar.classList.add('hc-sticky-atc--visible');
          bar.setAttribute('aria-hidden', 'false');
        } else {
          bar.classList.remove('hc-sticky-atc--visible');
          bar.setAttribute('aria-hidden', 'true');
        }
      });
    }, { threshold: 0 });

    observer.observe(nativeBtn);

    // Keep size label in sync when shopper selects a variant
    var variantSelects = document.querySelector('variant-selects');
    if (variantSelects && sizeLabel) {
      variantSelects.addEventListener('change', function () {
        var sizeOption = variantSelects.querySelector(
          'fieldset .form__label [data-selected-value], fieldset legend [data-selected-value]'
        );
        // Find the Size option specifically
        var fieldsets = variantSelects.querySelectorAll('fieldset');
        fieldsets.forEach(function (fs) {
          var legend = fs.querySelector('legend');
          if (legend && /size/i.test(legend.textContent)) {
            var checked = fs.querySelector('input[type="radio"]:checked');
            if (checked) sizeLabel.textContent = checked.value;
          }
        });
      });
    }

    // Re-evaluate on window resize (e.g. orientation change)
    window.addEventListener('resize', function () {
      if (window.innerWidth > MOBILE_MAX) {
        bar.classList.remove('hc-sticky-atc--visible');
        bar.setAttribute('aria-hidden', 'true');
      }
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
